import { render, staticRenderFns } from "./DrUserForm.vue?vue&type=template&id=f238c9d8&"
import script from "./DrUserForm.vue?vue&type=script&lang=js&"
export * from "./DrUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports